function updatePercentageBar() {
  // Fetch values from the elements
  if (!document.getElementById("number-of-results") && !document.getElementById("total-number-of-results")) {
    return;
  }
  const numberOfResults = parseInt(
    document.getElementById("number-of-results").innerText,
    10
  );
  const totalNumberOfResults = parseInt(
    document.getElementById("total-number-of-results").innerText,
    10
  );

  // Check if total number of results is not zero to avoid division by zero
  if (totalNumberOfResults === 0) {
    return; // No need to calculate if the total is zero
  }

  // Calculate the percentage
  const percentage = (numberOfResults / totalNumberOfResults) * 100;

  // Update the width of the showing-persentage div
  const percentageBar = document.querySelector(".showing-persentage");
  percentageBar.style.width = percentage + "%";
}

// Run the function to update the percentage bar
updatePercentageBar();

function extractElementFromHTML(htmlString, tagName) {
  // Create a temporary container element
  var tempContainer = document.createElement("div");
  tempContainer.innerHTML = htmlString;

  // Find the element by tag name
  var element = tempContainer.querySelector(tagName);

  // Return the element or null if not found
  return element;
}

async function loadMore(event, mode) {
  try {
    event.preventDefault();
    const linkSearchParams = new URLSearchParams(event.target.href.split('?')[1]);
    const pageNum = linkSearchParams.get('page');
    let url = event.target.href;
    let headersList = {
      Accept: "*/*",
      "User-Agent": "Thunder Client (https://www.thunderclient.com)",
    };

    let response = await fetch(`${url}`, {
      method: "GET",
      headers: headersList,
    });
    let data = await response.text();
    const existing_elem = document.querySelector(".load-more-content-show");
    const renderElem = extractElementFromHTML(data, ".load-more-content-show");
    if(mode === 'prev'){
      const existingLoadPrev = document.querySelector(".load-previous");
      const renderLoadPrev = extractElementFromHTML(data,".load-previous");
      existing_elem.insertAdjacentHTML('afterbegin',renderElem.innerHTML);
      if(renderLoadPrev){
        existingLoadPrev.replaceWith(renderLoadPrev);
      } else {
        let newDiv = document.createElement("div");
        newDiv.className = "load-previous";
        existingLoadPrev.replaceWith(newDiv);
      }
      // If page 1 loaded, inline banner is now present - enable solo item hiding
      if (parseInt(pageNum) === 1) {
        const productGrid = document.getElementById('product-grid');
        if (productGrid) {
          productGrid.classList.add('has-inline-banner');
          // Add portrait class for mobile hiding if banner type is portrait
          if (productGrid.dataset.inlineBannerType === 'portrait') {
            productGrid.classList.add('banner-type-portrait');
          }
        }
      }
    } else {
      const existing_load_button = document.querySelector(".pagination-component");
      const renderLoadMore = extractElementFromHTML(data,".pagination-component");
      // existing_elem.innerHTML += renderElem.innerHTML;
      existing_elem.insertAdjacentHTML('beforeend',renderElem.innerHTML);
      if (renderLoadMore) {
        existing_load_button.replaceWith(renderLoadMore);
        updatePercentageBar();
      } else {
        let newDiv = document.createElement("div");
        newDiv.className = "pagination-component";
        existing_load_button.replaceWith(newDiv);
        // All products loaded - show any hidden solo items
        document.getElementById('product-grid')?.classList.add('all-products-loaded');
      }
      //update page param in url
      const pageUrl = new URL(window.location.href);
      pageUrl.searchParams.set('page', parseInt(pageNum));   
      window.history.pushState({path:pageUrl.href}, '', pageUrl.href);
    }
  } catch (err) {
    // console.log(err);
  }
}


// filters hide show .....
function desktopMenuShowHide() {
  console.clear()
  try {
    const mediaQuery = window.matchMedia('(min-width: 650px)');
    if (mediaQuery.matches) {
      const filterDiv = document.querySelector('.custom-style-filters-part')
      const filterDivWidth = filterDiv.offsetWidth;
      const upArrow = document.querySelector('.up-arrow')
      const downArrow = document.querySelector('.down-arrow')
      const ShowingTextElem = document.querySelector('#filter-menu-text')

      if (filterDivWidth > 0) {
        filterDiv.style.width = '0px';
        filterDiv.style.overflow = 'hidden';
        filterDiv.parentNode.style.gap = "0px";
        upArrow.style.display = 'none'
        downArrow.style.display = 'block'
        ShowingTextElem.innerText = 'Show Filters'
      } else {
        filterDiv.style.width = '260px';
        filterDiv.parentNode.style.gap = "47px";
        filterDiv.style.overflow = 'visible';
        upArrow.style.display = 'block'
        downArrow.style.display = 'none'
        ShowingTextElem.innerText = 'Hide Filters'
      }
    }
  } catch (error) {

  }
}